<template>
  <form>
    <div class="row g-3">
      <div class="col-12">
        <div class="card shadow-sm border-0">
          <div class="card-body py-3 px-3">
            <h6 class="fw-bold mb-2" v-if="platform?.requires">
              Requisitos del curso
            </h6>
            <ul
              v-if="platform?.requires"
              class="list-unstyled mb-0 small"
            >
              <li
                v-for="(req, index) in platform.requires.split('\r\n')"
                :key="index"
                class="d-flex align-items-start mb-1"
              >
                <span class="me-2">•</span>
                <span>{{ req }}</span>
              </li>
            </ul>
            <p
              v-else
              class="text-muted mb-0 small fst-italic"
            >
              No se registraron requisitos para este curso.
            </p>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card shadow-sm border-0 d-flex flex-column">
          <div class="card-body py-3 px-3 d-flex flex-column">
            <div
              class="mb-2 d-flex justify-content-between align-items-center"
            >
              <h6 class="fw-bold mb-0">Tus archivos</h6>
            </div>

            <div
              v-if="filesUser && filesUser.length > 0"
              class="mb-3"
            >
              <div
                v-for="item in filesUser"
                :key="item.id"
                class="d-flex align-items-center justify-content-between py-1 px-2 rounded-3 mb-1 bg-light"
                v-if="
                  (idTypeStatus == 1 &&
                    filesUser &&
                    filesUser.length > 0) ||
                  (idTypeStatus == 2 &&
                    filesUser &&
                    filesUser.length > 0)
                "
              >
                <a
                  :href="item.url_file"
                  target="_blank"
                  class="text-decoration-none text-dark small text-truncate me-2"
                >
                  {{ item.name }}
                </a>
                <button
                  type="submit"
                  class="btn btn-sm bg-gradient-fvf-switch rounded-circle d-flex align-items-center justify-content-center"
                  style="
                    width: 32px;
                    height: 32px;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
                  "
                  @click.prevent="$emit('delete-file', item.id)"
                >
                  <font-awesome-icon
                    :icon="['fas', 'trash']"
                    style="color: #CE0D0D; font-size: 16px;"
                  ></font-awesome-icon>
                </button>
              </div>
            </div>

            <div class="mt-auto" v-if="
              idTypeStatus == 1 ||
              idTypeStatus == 2
            ">
              <file-pond
                ref="filePondRef"
                name="image"
                :model-value="urlFile"
                @update:model-value="$emit('update:urlFile', $event)"
                allow-multiple="true"
                class="w-100 h-100 mb-2"
                label-idle="Arrastre o seleccione los archivos"
              ></file-pond>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script setup>
import { ref, watch } from 'vue';
import vueFilePond from 'vue-filepond';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

const props = defineProps({
  platform: {
    type: Object,
    default: () => null
  },
  filesUser: {
    type: Array,
    default: () => []
  },
  idTypeStatus: {
    type: Number,
    default: 0
  },
  urlFile: {
    type: [String, Array],
    default: ''
  }
});

const emit = defineEmits(['delete-file', 'update:urlFile', 'upload-files']);

const filePondRef = ref(null);

const uploadFiles = () => {
  const filePondInstance = filePondRef.value?.getFiles();
  if (filePondInstance && filePondInstance.length > 0) {
    emit('upload-files', filePondInstance);
  }
};

// Exponer método para que el padre pueda llamarlo
defineExpose({
  uploadFiles
});
</script>